import LazyPageLoader from '../../cmp/LazyPageLoader';
import React from 'react'
const Page = React.lazy(()=>import('./TipaltiIndex'))

export default function TipaltiIndex(props){
    return <React.Suspense fallback={<LazyPageLoader />}>
        <Page />
    </React.Suspense>
}
